module.exports = __webpack_public_path__ + "img/audio.beca0009.png";